import { AccountType } from "@common/constants/domains/accounting/accounts";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ScheduleSourceType } from "@common/types/domains/accounting/schedule";
import { BulkScheduleRow } from "./bulkScheduleRows";

export function toTransactionBulkScheduleRow(options: {
    transaction: TransactionListItem;
    accountType: AccountType | null;
}): BulkScheduleRow {
    const { transaction, accountType } = options;
    return {
        entityId: transaction.entity.id,
        source: {
            sourceType: ScheduleSourceType.transaction,
            transactionId: transaction.id,
            amount: Math.abs(transaction.amount),
        },
        existingApplicationIds: transaction.schedule
            ? [transaction.schedule.scheduleApplicationId]
            : [],
        existingTemplateId: transaction.schedule?.scheduleTemplateId ?? null,
        hasMatchedSchedule: (transaction.matchedSchedules?.length ?? 0) > 0,
        blockReason: null,
        transactionAmount: transaction.amount,
        accountType,
    };
}
